<template>
  <v-container>
    <v-row>
      <v-col cols="5">
        <form-bike :data="info" @update="updateForm"></form-bike>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-row>
              <v-col>
                <v-btn @click="cancel" color="error" outlined="outlined" large="large" min-width="160">{{ $t('buttons.cancel') }}</v-btn>
              </v-col>
              <v-col>
                <v-btn @click="confirm" color="primary" large="large" min-width="160">{{ $t('buttons.update') }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="7">
        <info-card class="mb-10" :info="info"></info-card>
        <div class="map-wrap">
          <google-map :zoom="range.zoom" :paths="range.paths" :center="range.position"></google-map>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from '@/components/GoogleMap'
import InfoCard from '@/components/Bikes/InfoCard'
import FormBike from '@/components/Bikes/Forms/Bike'

export default {
  components: { FormBike, InfoCard, GoogleMap },
  data () {
    return {
      info: {
        model: 'SCP0305',
        id: 'acac0304',
        appVersion: 'E2342.34',
        certificate: '289348v382c32',
        productionDate: '2019/12/22',
        maintenance: '信義安和站',
        rental: 'RESERVED',
        status: 'NORMAL',
        battery: '88%',
        updateAt: '2020/02/20/13:00'
      }
    }
  },
  computed: {
    ...mapGetters({
      stations: 'station/list',
      range: 'range/data'
    })
  },
  methods: {
    updateForm ({ field, value }) {
      this.form[field] = value
    },
    cancel () {
      this.back()
    },
    confirm () {
      this.back()
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .text-underline
    border-bottom 1px solid $primary
</style>
